import React from 'react';
import { control, button } from 'react-validation';
import NumberFormat from 'react-number-format';

import './Form.scss';

const Input = ({ type = 'text', error, isChanged, isUsed, ...props }) => {
  const classState = error && isChanged && isUsed ? 'has-error' : '';
  return (
    <div className={'form-group ' + classState + ' col-md-6'}>
      <label className="control-label">
        {props.label} <span className="wish-info">{props.sublabel}</span>
        <input type={type} className="form-control donation" {...props} />
      </label>
      <span className="help-block ">
        {error && isChanged && isUsed ? error : ' '}
      </span>
    </div>
  );
};

const Textarea = ({ error, isChanged, isUsed, ...props }) => {
  const classState = error && isChanged && isUsed ? 'has-error' : '';
  return (
    <div className={'form-group ' + classState + ' col-md-12'}>
      <label className="control-label">
        {props.label} <span className="wish-info">{props.sublabel}</span>
        <textarea className="form-control donation" {...props} />
      </label>
      <span className="help-block ">
        {error && isChanged && isUsed ? error : ' '}
      </span>
    </div>
  );
};

const CurrencyInput = ({ error, isChanged, isUsed, ...props }) => {
  const renderText = value => {
    return <Input className="form-control donation" {...props} />;
  };
  return (
    <React.Fragment>
      <NumberFormat
        className="form-control donation donation-price"
        value={props.value}
        thousandSeparator={'.'}
        decimalSeparator={','}
        decimalScale={2}
        allowNegative={false}
        suffix={'€'}
        renderText={renderText}
        fixedDecimalScale={true}
        {...props}
      />
      <span className="help-block">
        {error && isChanged && isUsed ? error : ' '}
      </span>
    </React.Fragment>
  );
};

const Checkbox = ({ error, isChanged, isUsed, ...props }) => {
  const classState = error && isChanged && isUsed ? 'has-error' : '';
  return (
    <div className={'col-md-12 ' + classState}>
      <div className="checkbox">
        <label>
          <input type="checkbox" {...props} />
          <span className="cr">
            <i className="cr-icon fa fa-check" />
          </span>
          {props.label}
        </label>
      </div>
    </div>
  );
};

const Button = ({ hasErrors, ...props }) => {
  let combineClasses = 'btn btn-default ';
  if (props.classes) combineClasses = combineClasses + props.classes;
  return <button className={combineClasses} {...props} disabled={hasErrors} />;
};

export const DonationInput = control(Input);
export const DonationTextarea = control(Textarea);
export const DonationCurrencyInput = control(CurrencyInput);
export const DonationCheckbox = control(Checkbox);
export const DonationButton = button(Button);



// WEBPACK FOOTER //
// ./src/Validation/Form.js